<template>
    <div class="row">
        <form @submit.prevent="current ? update() : addNew()">
            <div class="panel panel-primary">
                <div class="panel-heading">Add New Product</div>
                <div class="panel-body" v-if="form">
                    <div class="form-group row">
                        <div class="col-xs-12">
                            <vue-dropzone
                                ref="productImageDropzone"
                                id="dropzone"
                                :options="dropzoneOptions"
                                @vdropzone-success="fileUploaded"
                                @vdropzone-removed-file="fileDeleted"
                            ></vue-dropzone>
                        </div>
                    </div>
                    <div class="form-group row">
                        <div class="col-xs-12 col-sm-4 col-md-4 col-lg-4">
                            <label>Name *</label>
                            <input class="form-control" v-model="form.name" placeholder="Product Name" />
                        </div>
                        <div class="col-xs-12 col-sm-4 col-md-4 col-lg-4">
                            <label>Description *</label>
                            <textarea v-model="form.description" class="form-control"></textarea>
                        </div>

                        <div class="col-xs-12 col-sm-4 col-md-4 col-lg-3">
                            <label>Price *</label>
                            <input class="form-control" v-model="form.priceFormatted" placeholder="Product Price" />
                        </div>

                        <div class="col-xs-12 col-sm-4 col-md-4 col-lg-1">
                            <label>Personalised</label>
                            <input class="form-control" type="checkbox" v-model="form.personalised"  value="0"/>
                        </div>

                    </div>
                    <div class="product-variants">
                        <div class="form-group row" v-for="(variant, key) in form.variants">
                            <div class="col-xs-12 col-sm-4">
                                <label>Type</label>
                                <input class="form-control" v-model="variant.label">
                            </div>
                            <div class="col-xs-12 col-sm-4">
                                <label>Value</label>
                                <input class="form-control" v-model="variant.value">
                            </div>
                            <div class="col-xs-12 col-sm-3">
                                <label>Price Addon</label>
                                <input class="form-control" v-model="variant.priceFormatted">
                            </div>
                            <div class="col-xs-12 col-sm-1">
                                <label>&nbsp;</label>
                                <p><button type="button" class="btn btn-danger" @click.prevent="removeVariant(key)"><i class="glyphicon glyphicon-remove"></i></button></p>
                            </div>
                        </div>

                        <p><button type="button" class="btn btn-success" @click.prevent="newVariant()">Add variant</button></p>
                    </div>
                </div>
                <div class="panel-footer">
                    <button type="submit" class="btn btn-success pull-right">{{ buttonLabel }}</button>
                    <div class="clearfix"></div>
                </div>
            </div>
        </form>
    </div>
</div>
</template>

<script>
    import Form from '../utils/Form';
    import vue2Dropzone from 'vue2-dropzone';

    export default {
        components: {
            vueDropzone: vue2Dropzone
        },

        props: [
            'current'
        ],

        data: function () {
            return {
                form: new Form({
                    name: this.current ? this.current.name : null,
                    description: this.current ? this.current.description : null,
                    priceFormatted: this.current ? this.currency(this.current.price) : null,
                    variants: this.current ? _.map(this.current.variants, function (variant) {
                        variant.priceFormatted = variant.price / 100;
                        return variant;
                    }) : [],
                    price: this.current ? this.current.price : null,
                    personalised: this.current ? this.current.personalised : false,
                    images: []
                }),
                buttonLabel: this.current ? 'Update Product' : 'Save New Product',
                dropzoneOptions: {
                    url: '/api/v1/products/upload-thumbnail',
                    thumbnailWidth: 200,
                    maxFilesize: 5,
                    headers: {
                          'X-CSRF-TOKEN': document.head.querySelector('meta[name="csrf-token"]').content
                    },
                    addRemoveLinks: true
                }
            };
        },

        mounted() {
            if (this.current) {
                this.form.images = _.map(this.current.images, 'id');

                for (let file of this.current.images) {
                    this.$refs.productImageDropzone.manuallyAddFile({
                        name: file.filename,
                        type: file.mime_type,
                        size: file.size
                    }, file.thumb_url);
                }
            }
        },

        methods: {
            addNew() {
                this.form.price = this.form.priceFormatted * 100;
                _.map(this.form.variants, function (variant) {
                    variant.price = variant.priceFormatted * 100;
                    return variant;
                });

                this.form.post('/api/v1/products')
                    .then(response => {
                        this.$emit('changed');
                    })
                    .catch(error => {
                        if (error.errors) {
                            // We use fat arrow functions instead of function() because using fat arrows means we have access to "this"
                            _.forOwn(error.errors, (errors, field_name) => {
                                _.each(errors, (value, key) => {
                                    this.$message({message: value, type: 'error'});
                                    console.log('Error: ' + value);
                                    console.log('Field: ' + field_name);
                                });
                            });
                        }
                        else {
                            this.$message({message: 'There was a problem saving the product.', type: 'error'});
                        }

                    });
            },

            update() {
                this.form.price = this.form.priceFormatted * 100;
                _.map(this.form.variants, function (variant) {
                    variant.price = variant.priceFormatted * 100;
                    return variant;
                });

                this.form.put(`/api/v1/products/${this.current.id}`)
                    .then(response => {
                        this.$emit('changed');
                    })
                    .catch(error => {
                        if (error.errors) {
                            // We use fat arrow functions instead of function() because using fat arrows means we have access to "this"
                            _.forOwn(error.errors, (errors, field_name) => {
                                _.each(errors, (value, key) => {
                                    this.$message({message: value, type: 'error'});
                                    console.log('Error: ' + value);
                                    console.log('Field: ' + field_name);
                                });
                            });
                        }
                        else {
                            this.$message({message: 'There was a problem saving the product.', type: 'error'});
                        }
                    });
            },

            currency(value) {
                return (value / 100);
            },

            newVariant() {
                this.form.variants.push({
                    id: null,
                    label: null,
                    value: null,
                    price: null
                });
            },

            removeVariant(variant) {
                this.form.variants.splice(variant, 1);
            },

            fileUploaded(file, response) {
                this.form.images.push(response.image_id);
            },

            fileDeleted(file, error, xhr) {
                if (file.manuallyAdded) {
                    let deletedFile = _.find(this.current.images, (f) => f.filename == file.name);
                    let fileId = this.form.images.indexOf(deletedFile.id);

                    this.form.images = this.form.images.splice(fileId, 1);
                } else {
                    let response = JSON.parse(file.xhr.response);
                    let fileId = this.form.images.indexOf(response.image_id);
                    this.form.images = this.form.images.splice(fileId, 1);
                }

            }
        },

        destroyed() {
            this.form = null;
        }
    }
</script>

<style scoped>
    @import url('~vue2-dropzone/dist/vue2Dropzone.min.css');
</style>
